var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bell-2 1"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6215_27107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.9844 10.882C21.4323 10.882 20.9844 10.4341 20.9844 9.88202C20.9844 7.07703 19.8924 4.44104 17.9093 2.45691C17.5184 2.06598 17.5184 1.43408 17.9093 1.04297C18.3003 0.652039 18.9324 0.652039 19.3233 1.04297C21.6844 3.40393 22.9843 6.54309 22.9843 9.88202C22.9843 10.4341 22.5364 10.882 21.9844 10.882Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.98431 10.882C1.43243 10.882 0.984375 10.4341 0.984375 9.88202C0.984375 6.54309 2.28442 3.40393 4.64539 1.04297C5.03632 0.652039 5.6684 0.652039 6.05933 1.04297C6.45044 1.43408 6.45044 2.06598 6.05933 2.45691C4.07629 4.43994 2.98444 7.07703 2.98444 9.88202C2.98444 10.4341 2.53638 10.882 1.98431 10.882Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.3635 16.9131C19.8514 15.635 18.9844 13.767 18.9844 11.788V9C18.9844 5.85579 16.8974 3.19531 14.0376 2.31626C13.445 2.13411 12.9844 1.61991 12.9844 0.999939C12.9844 0.44696 12.5363 0 11.9844 0C11.4324 0 10.9843 0.44696 10.9843 0.999939C10.9843 1.6199 10.5237 2.13409 9.93112 2.31619C7.07064 3.19517 4.98431 5.85571 4.98431 9V11.788C4.98431 13.767 4.11731 15.635 2.59644 16.921C2.20734 17.254 1.98431 17.738 1.98431 18.2499C1.98431 19.2151 2.76929 20.0001 3.73444 20.0001H20.2344C21.1994 20.0001 21.9844 19.2151 21.9844 18.2499C21.9844 17.738 21.7614 17.254 21.3635 16.9131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.9844 24C12.4879 24 12.9685 23.9002 13.4075 23.7194C15.1628 22.9964 13.8825 21 11.9842 21C10.0861 21 8.80585 22.9962 10.5609 23.7192C11 23.9002 11.4808 24 11.9844 24Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6215_27107"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell2);
export default __webpack_public_path__ + "static/media/bell-2.1ddce92a.svg";
export { ForwardRef as ReactComponent };